import { useMutation } from "react-query";
import { t } from "@/i18n-js/instance";
import type { UpdateAttemptPayload } from "@/react/api/quizAttemptsApi";
import { quizAttemptsApi } from "@/react/api/quizAttemptsApi";
import { useToast } from "@circle-react-uikit/ToastV2";

interface UseUpdateQuizAttemptParams {
  attemptId: number;
  onSuccess: () => void;
  quizId: number;
}
export const useUpdateQuizAttempt = ({
  quizId,
  attemptId,
  onSuccess,
}: UseUpdateQuizAttemptParams) => {
  const { error, success } = useToast();
  const { mutate, isLoading: isSaving } = useMutation(
    (payload: UpdateAttemptPayload) =>
      quizAttemptsApi.update({ quizId: quizId, id: attemptId, payload }),
    {
      onSuccess: () => {
        onSuccess();
        success(
          t("courses.admin_summary.engagement.quiz_results.result_saved"),
        );
      },
      onError: () => {
        error(
          t("courses.admin_summary.engagement.quiz_results.result_save_error"),
        );
      },
    },
  );

  return { mutate, isSaving };
};
